import React from 'react';
import _ from 'lodash';
import cx from 'classnames';


export const StatusDot = ({ status, size, className, ...props}) => 
    <div {...props} className={cx('g-status-dot', status, size, className)} />
  
export default StatusDot;